require('./mortgageRequestOperativeGeneralData.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { formatText } = require('core/i18n').i18n;
const { connect } = require('react-redux');
// @ commons
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');

// @ helpers
const { formatCurrency, formatAmount } = require('utilities/currencyHelper');

// @ components
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ actions
const getOperativeGeneralDataAction= require('actions/mortgageRequest/mortgageRequestOperativeGeneralData');

class MortgageRequestOperativeGeneralData extends React.Component {

    constructor(props) {
        super(props);
    }

    componentWillMount() {
        const { requestOperativeGeneralData, product, contractNumber } = this.props;

        requestOperativeGeneralData(product, contractNumber);
    }

    render() {
        let content;
        let interestMode;
        const { operativeGeneralData, contractNumber } = this.props;
        const title = formatText('mortgageRequestOperativeGeneralData-title');
        const currencyFormatted  = formatCurrency(operativeGeneralData.get('divisa'));
        const modalidadTipoInteresDescuadre = operativeGeneralData.get('modalidadTipoInteresDescuadre');
        const modalidadTipoInteresActual = operativeGeneralData.get('modalidadTipoInteresActual');
        const modalidaTipoInteresDiferencial = operativeGeneralData.get('modalidaTipoInteresDiferencial');

        const itemList = (text1, text2) => {
            return (
                <li className="mortgage-request-operative-general-data__element">
                    <span className="mortgage-request-operative-general-data__item">
                        {text1}
                    </span>
                    <span
                        className="mortgage-request-operative-general-data__item--bold"
                    >
                        {text2}
                    </span>
                </li>
            )
        };

        if (modalidadTipoInteresDescuadre) {
            interestMode = `${modalidadTipoInteresDescuadre} ${modalidadTipoInteresActual} ${modalidaTipoInteresDiferencial}`;
        } else {
            interestMode = `${formatText('mortgageRequestOperativeGeneralData-typeOfCurrentInterest')} ${modalidadTipoInteresActual}`;
        }

        if (operativeGeneralData.get('isFetching')) {
            content = <LoadingSection />
        } else {
            content = (
                <div className="mortgage-request-operative-general-data">

                    <OKBoxTitle value={title} />

                    <div className="mortgage-request-operative-general-data__body row">

                        <ul className="list-unstyled col-xs-6">
                            {itemList(formatText('mortgageRequestOperativeGeneralData-initialMoney'),`${formatAmount(operativeGeneralData.get('capitalInicial'))} ${currencyFormatted}`)}
                            {itemList(formatText('mortgageRequestOperativeGeneralData-initDate'), operativeGeneralData.get('fechaApertura'))}
                            {itemList(formatText('mortgageRequestOperativeGeneralData-mortgageContract'), contractNumber)}
                            {itemList(formatText('mortgageRequestOperativeGeneralData-interestModality'), interestMode)}
                        </ul>

                        <ul className="list-unstyled col-xs-6">
                            {itemList(formatText('mortgageRequestOperativeGeneralData-dueDate'), operativeGeneralData.get('fechaVencimientoActual'))}
                            {itemList(formatText('mortgageRequestOperativeGeneralData-associatedAccount'), operativeGeneralData.get('cuentaAsociada'))}
                            {itemList(formatText('mortgageRequestOperativeGeneralData-interestType'), operativeGeneralData.get('tipoInteres'))}
                        </ul>

                    </div>

                </div>
            );
        }

        return content;
    }
}

MortgageRequestOperativeGeneralData.propTypes = {
    operativeGeneralData: PropTypes.object,
    product: PropTypes.string.isRequired,
    contractNumber: PropTypes.string.isRequired,
    requestOperativeGeneralData: PropTypes.func
};

MortgageRequestOperativeGeneralData.defaultProps = {
    product: '',
    contractNumber: '',
};

module.exports.constructor = MortgageRequestOperativeGeneralData;
module.exports.MortgageRequestOperativeGeneralData = connect(
    state => ({
        operativeGeneralData: state.mortgageRequestOperativeGeneralData
    }), {
        requestOperativeGeneralData: getOperativeGeneralDataAction.requestOperativeGeneralData
    }
)(MortgageRequestOperativeGeneralData);